__turbopack_context__.v({
  "belowConversionBar": "Toast-module-scss-module__UUf2MG__belowConversionBar",
  "content": "Toast-module-scss-module__UUf2MG__content",
  "error": "Toast-module-scss-module__UUf2MG__error",
  "fadeIn": "Toast-module-scss-module__UUf2MG__fadeIn",
  "heroCarousel": "Toast-module-scss-module__UUf2MG__heroCarousel",
  "info": "Toast-module-scss-module__UUf2MG__info",
  "success": "Toast-module-scss-module__UUf2MG__success",
  "toast": "Toast-module-scss-module__UUf2MG__toast",
  "warning": "Toast-module-scss-module__UUf2MG__warning",
});
